export class OrdenServicio {
  idOrdenServicio: number;
  ordenServicio: string;
  fechaIngreso: Date;
  fechaEntrega: Date;
  fechaPromesa: Date;
  fechaPromesaReprogramada: Date;
  avance: number;
  idAseguradora: number;
  idStatusOrdenServicio: number;
  siniestro: string;
  magnitud: string;
  idCliente: number;
  proceso: string;
  idFolio: number;
  tipoServicio: string;
  facturado: boolean;
  fechaFacturado: Date;
  empleadoFacturacion: string;
  ajustador: string;
  telefonoAjustador: string;
  perdidaTotal: boolean;
  cancelada: boolean;
  observaciones: string;
  marcar: boolean;
  statusOS: string;
}

export interface FechaPromesaReprogramada {
  idOrdenServicio: number;
  idEmpleado: number;
  fechaPromesa: string;
  motivoReprogramacion: string;
}

export interface OrdenServicioFechaPromesa {
  idOrdenServicioFechaPromesa: number;
  idOrdenServicio: number;
  empleado: string;
  fechaPromesa: string;
  motivoReprogramacion: string;
  fechaRegistro: string;
}

export interface PdfReporteTrabajoGenerado {
  nombreArchivo: string;
  url: string;
  empleado: string;
  fecha: Date;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/ordenServicio.ts